<script>
  import router from 'page';

  // Include our Routes
  import Index from './pages/Index.svelte';
  import NotFound from './pages/NotFound.svelte';

  let page;
  let params;

  // Set up the pages to watch for
  router('/', () => page = Index);
  router('/*', () => page = NotFound);

  // Set up the router to start and actively watch for changes
  router.start();
</script>

<header>
	<nav><a href="/">Home</a></nav>
</header>

<svelte:component this={page} params={params}/>